const Errors = {
  SERVER_UNAVAILABLE: "Ocurrió un error en la petición, por favor intenta nuevamente.",
}

const ComplaintsStatus = {
  PENDING: { key: 1, label: 'PENDIENTE', color: 'badge-red' },
  RESPONDED: { key: 2, label: 'ATENDIDO', color: 'badge-green' },
  FILED: { key: 3, label: 'ARCHIVADO', color: 'badge-gray' }
}

const WellTypeValues = {
  PRODUCT: { key: 1, label: 'PRODUCTO' },
  SERVICE: { key: 2, label: 'SERVICIO' }
}

const ReportTypeValues = {
  COMPLAINT: { key: 1, label: 'QUEJA' },
  CLAIM: { key: 2, label: 'RECLAMO' }
}

const IsUnderage = {
  NOT: { key: 0, label: 'NO' },
  YES: { key: 1, label: 'SI' }
}

const ConfigLogoDimensions = {
  width: 272,
  height: 90
}

const BrandsStatus = {
  ACTIVE: { key: 1, label: "ACTIVO", color: "badge-green", action: "Suspender" },
  INACTIVE: { key: 2, label: "SUSPENDIDO", color: "badge-yellow", action: "Activar" },
}

const UsersStatus = {
  ACTIVE: {
    key: true,
    label: "ACTIVO",
    color: "badge-green",
    action: "Suspender",
  },
  INACTIVE: {
    key: false,
    label: "SUSPENDIDO",
    color: "badge-yellow",
    action: "Activar",
  },
}

const LocationStatus = {
  ACTIVE: { key: 1, label: "ACTIVO", color: "badge-green", action: "Suspender" },
  INACTIVE: { key: 2, label: "SUSPENDIDO", color: "badge-yellow", action: "Activar" },
}

const ProfileTypes = {
  SUPER_ADMINISTRATOR: { key: 'ROLE_SUPER_ADMINISTRATOR', label: "SUPER ADMINISTRADOR" },
  ADMINISTRATOR: { key: 'ROLE_ADMINISTRATOR', label: "ADMINISTRADOR" },
  SUPERVISOR: { key: 'ROLE_SUPERVISOR', label: "SUPERVISOR" }
}

export default {
  Errors,
  ComplaintsStatus,
  WellTypeValues,
  ReportTypeValues,
  IsUnderage,
  ConfigLogoDimensions,
  UsersStatus,
  BrandsStatus,
  LocationStatus,
  ProfileTypes
}
